"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertParamsForEncode = void 0;

var _slugify = require("../helpers/slugify");

var _SeoManagerHelpers = require("../helpers/SeoManagerHelpers");

var getGeo = function getGeo(el) {
  var getTypeL10 = function getTypeL10(t) {
    if (t.zone || t.adm) {
      return 'zone';
    } else if (t.street) {
      return 'indirizzi';
    } else if (t.zci) {
      return 'zone commerciali';
    }

    return 'zone';
  };

  var getParentL16 = function getParentL16(l6) {
    if (l6 && l6["short"] && !isNaN(l6["short"])) {
      return {
        region: {
          level: 4,
          name: 'Provence-Alpes-Cote Azur',
          slug: (0, _slugify.slugify)('Provence-Alpes-Cote-Azur')
        }
      };
    }

    return {};
  };

  if (el.l4 && Object.keys(el).length === 1) {
    // region
    return {
      level: 4,
      type: 'region',
      name: el.l4.adm,
      slug: (0, _slugify.slugify)(el.l4.adm),
      parent: {}
    };
  } else if (el.l4 && el.l6 && Object.keys(el).length === 2) {
    // province
    return {
      level: 6,
      type: 'province',
      name: el.l6["short"] && _SeoManagerHelpers.PROVINCES_BY_SHORT[el.l6["short"]] ? _SeoManagerHelpers.PROVINCES_BY_SHORT[el.l6["short"]].name : el.l6.adm,
      slug: el.l6["short"] && _SeoManagerHelpers.PROVINCES_BY_SHORT[el.l6["short"]] ? _SeoManagerHelpers.PROVINCES_BY_SHORT[el.l6["short"]].slug : (0, _slugify.slugify)(el.l6.adm),
      "short": el.l6["short"] || el.l6.adm,
      parent: {
        region: {
          level: 4,
          name: el.l4.adm,
          slug: (0, _slugify.slugify)(el.l4.adm)
        }
      }
    };
  } else if (el.l4 && el.l6 && el.l9 && Object.keys(el).length === 3) {
    // town
    return {
      level: 9,
      type: 'town',
      name: el.l9.adm,
      slug: (0, _slugify.slugify)(el.l9.adm),
      parent: {
        region: {
          level: 4,
          name: el.l4.adm,
          slug: (0, _slugify.slugify)(el.l4.adm)
        },
        province: {
          level: 6,
          name: el.l6.adm,
          slug: (0, _slugify.slugify)(el.l6.adm),
          "short": el.l6["short"] || el.l6.adm
        }
      }
    };
  } else if (el.l4 && el.l6 && el.l9 && el.l10 && Object.keys(el).length === 4) {
    // zone
    return {
      level: 10,
      type: getTypeL10(el.l10),
      name: el.l10.zone || el.l10.adm || el.l10.street || el.l10.zci,
      slug: (0, _slugify.slugify)(el.l10.zone || el.l10.adm || el.l10.street || el.l10.zci),
      parent: {
        region: {
          level: 4,
          name: el.l4.adm,
          slug: (0, _slugify.slugify)(el.l4.adm)
        },
        province: {
          level: 6,
          name: el.l6.adm,
          slug: (0, _slugify.slugify)(el.l6.adm),
          "short": el.l6["short"] || el.l6.adm
        },
        town: {
          level: 9,
          name: el.l9.adm,
          slug: (0, _slugify.slugify)(el.l9.adm)
        }
      }
    };
  } else if (el.l6 && el.l9 && el.l10 && Object.keys(el).length === 3) {
    // zone
    return {
      level: 10,
      type: getTypeL10(el.l10),
      name: el.l10.zone || el.l10.adm || el.l10.street || el.l10.zci,
      slug: (0, _slugify.slugify)(el.l10.zone || el.l10.adm || el.l10.street || el.l10.zci),
      parent: {
        province: {
          level: 6,
          name: el.l6.adm,
          slug: (0, _slugify.slugify)(el.l6.adm),
          "short": el.l6["short"] || el.l6.adm
        },
        town: {
          level: 9,
          name: el.l9.adm,
          slug: (0, _slugify.slugify)(el.l9.adm)
        }
      }
    };
  } else if ((el.l4 || el.l6 || el.l9) && Object.keys(el).length === 1) {
    // town
    return Object.assign({}, el.l4 ? {
      level: 4,
      type: 'region',
      name: el.l4.adm,
      slug: (0, _slugify.slugify)(el.l4.adm),
      parent: {}
    } : null, el.l6 ? {
      level: 6,
      type: 'province',
      name: el.l6.adm,
      slug: (0, _slugify.slugify)(el.l6.adm),
      "short": el.l6["short"] || el.l6.adm,
      parent: getParentL16(el.l6)
    } : null, el.l9 ? {
      level: 9,
      type: 'town',
      name: el.l9.adm,
      slug: (0, _slugify.slugify)(el.l9.adm),
      parent: {}
    } : null);
  } else if (el.l9 && el.l10 && Object.keys(el).length === 2) {
    // zone
    return {
      level: 10,
      type: getTypeL10(el.l10),
      name: el.l10.zone || el.l10.adm || el.l10.street || el.l10.zci,
      slug: (0, _slugify.slugify)(el.l10.zone || el.l10.adm || el.l10.street || el.l10.zci),
      parent: {
        town: {
          level: 9,
          name: el.l9.adm,
          slug: (0, _slugify.slugify)(el.l9.adm)
        }
      }
    };
  } else if (el.l6 && el.l9 && Object.keys(el).length === 2) {
    // town with province
    return {
      level: 9,
      type: 'town',
      name: el.l9.adm,
      slug: (0, _slugify.slugify)(el.l9.adm),
      parent: {
        province: {
          level: 6,
          name: el.l6.adm,
          slug: (0, _slugify.slugify)(el.l6.adm),
          "short": el.l6["short"] || el.l6.adm
        }
      }
    };
  } else if (el.l6 && el.l9 && el.l10 && el.l11 && Object.keys(el).length === 4) {
    // block 4 levels
    return {
      level: 11,
      type: 'block',
      name: el.l11.block,
      slug: (0, _slugify.slugify)(el.l11.block),
      parent: {
        province: {
          level: 6,
          name: el.l6.adm,
          slug: (0, _slugify.slugify)(el.l6.adm),
          "short": el.l6["short"] || el.l6.adm
        },
        town: {
          level: 9,
          name: el.l9.adm,
          slug: (0, _slugify.slugify)(el.l9.adm)
        },
        zone: {
          level: 10,
          name: el.l10.zone,
          slug: (0, _slugify.slugify)(el.l10.zone)
        }
      }
    };
  } else if (el.l9 && el.l10 && el.l11 && Object.keys(el).length === 3) {
    // block levels 3
    return {
      level: 11,
      type: 'block',
      name: el.l11.block,
      slug: (0, _slugify.slugify)(el.l11.block),
      parent: {
        town: {
          level: 9,
          name: el.l9.adm,
          slug: (0, _slugify.slugify)(el.l9.adm)
        },
        zone: {
          level: 10,
          name: el.l10.zone,
          slug: (0, _slugify.slugify)(el.l10.zone)
        }
      }
    };
  } else if (el.l10 && el.l11 && Object.keys(el).length === 2) {
    // block level 2
    return {
      level: 11,
      type: 'block',
      name: el.l11.block,
      slug: (0, _slugify.slugify)(el.l11.block),
      parent: {
        zone: {
          level: 10,
          name: el.l10.zone,
          slug: (0, _slugify.slugify)(el.l10.zone)
        }
      }
    };
  } else if (el.l9 && el.l118 && Object.keys(el).length === 2) {
    // metroline
    return {
      level: 118,
      type: 'metroline',
      name: el.l118.metroline,
      slug: (0, _slugify.slugify)(el.l118.metroline),
      parent: {
        town: {
          level: 9,
          name: el.l9.adm,
          slug: (0, _slugify.slugify)(el.l9.adm)
        }
      }
    };
  } else if (el.l9 && el.l118 && el.l120 && Object.keys(el).length === 3) {
    // metrostop
    return {
      level: 120,
      type: 'metrostop',
      name: el.l120.metrostop,
      slug: (0, _slugify.slugify)(el.l120.metrostop),
      parent: {
        town: {
          level: 9,
          name: el.l9.adm,
          slug: (0, _slugify.slugify)(el.l9.adm)
        },
        metroline: {
          level: 118,
          name: el.l118.metroline,
          slug: (0, _slugify.slugify)(el.l118.metroline)
        }
      }
    };
  } else {
    return Object.assign({}, {
      level: 9,
      type: 'town',
      name: '',
      slug: '',
      parent: {}
    });
  }
};

var getFreeText = function getFreeText(el) {
  if (el.text && Object.keys(el).length === 1) {
    return {
      level: 9,
      type: 'town',
      name: el.text,
      slug: (0, _slugify.slugify)(el.text),
      parent: {}
    };
  }
};

var convertParamsForEncode = function convertParamsForEncode(lang, params) {
  var isOldSeoUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var getLocations = function getLocations() {
    if (Array.isArray(params.geo)) {
      return params.geo.map(function (el) {
        return getGeo(el);
      });
    } else if (params.freetext && Array.isArray(params.freetext)) {
      return params.freetext.map(function (el) {
        return getFreeText(el);
      });
    } else {
      return [];
    }
  };

  var locations = getLocations();
  var seoQO = {};

  if (params.queryObject) {
    Object.keys(params.queryObject).map(function (k) {
      return seoQO[k] = params.queryObject[k];
    });
  }

  var getPropertyTypes = function getPropertyTypes() {
    if (params.propertyTypes) {
      if (!Array.isArray(params.propertyTypes)) {
        params.propertyTypes = [params.propertyTypes];
      }

      return {
        propertyTypes: params.propertyTypes.map(function (el) {
          return el.slug;
        })
      };
    } else {
      return null;
    }
  };

  var convertGeoParams = function convertGeoParams() {
    if (params.geo) {
      if (!Array.isArray(params.geo)) {
        params.geo = [params.geo];
      }

      return {
        qgeo: params.geo.map(function (el) {
          var qgeo = [];

          if (el.l4 && el.l4.adm) {
            qgeo.push("".concat(el.l4.adm));
          }

          if (el.l6 && el.l6["short"]) {
            qgeo.push("".concat(el.l6["short"]));
          }

          if (el.l9 && el.l9.adm) {
            qgeo.push("".concat(el.l9.adm));
          }

          if (el.l10 && el.l10.adm) {
            qgeo.push("".concat((0, _slugify.slugify)(el.l10.adm)));
          }

          return qgeo.join('@');
        })
      };
    } else {
      return null;
    }
  };

  var convertGeoToLocationsForEncode = function convertGeoToLocationsForEncode(geo) {
    if (!Array.isArray(geo)) {
      geo = [geo];
    }

    return geo.map(function (el) {
      return getGeo(el);
    });
  };

  var convertPropertyTypesForEncode = function convertPropertyTypesForEncode(ptypes) {
    if (!Array.isArray(ptypes)) {
      ptypes = [ptypes];
    }

    return ptypes.map(function (el) {
      return el.slug;
    });
  };

  var convertLicenseTypeGroupForEncode = function convertLicenseTypeGroupForEncode(ltg) {
    if (!Array.isArray(ltg)) {
      ltg = [ltg];
    }

    return ltg.map(function (el) {
      return el.slug;
    });
  };

  var convertSeoDecQOForEncode = function convertSeoDecQOForEncode(seoDec) {
    var obj = {};

    if (seoDec.queryObject) {
      Object.keys(seoDec.queryObject).map(function (k) {
        obj[k] = seoDec.queryObject[k];
      });
      return obj;
    }

    return null;
  };

  if ('publisher' in params && params.publisher && !Array.isArray(params.publisher)) {
    params.publisher = [params.publisher];
  }

  if ('misc' in params && (params.misc === 'undefined' || params.misc === undefined)) {
    delete params.misc;
  }

  if (isOldSeoUrl) {
    var seoParams = Object.assign({}, params, seoQO, getPropertyTypes(), {
      tr: _SeoManagerHelpers.TR_ENCODE[lang][params.tr] || 'vendita'
    }, params.publisherId ? {
      detailAgencyId: params.publisherId
    } : null, params.price && params.price.from ? {
      priceMin: params.price.from
    } : null, params.price && params.price.to ? {
      priceMax: params.price.to
    } : null, params.mq && params.mq.from ? {
      mqMin: params.mq.from
    } : null, params.mq && params.mq.to ? {
      mqMax: params.mq.to
    } : null, seoQO.surrounding ? {
      includeSurrounding: seoQO.surrounding
    } : null, {
      locations: locations
    }, convertGeoParams());

    if (!seoParams.photo || seoParams.photo === 'false') {
      delete seoParams.photo;
    }

    delete seoParams.seo_manager_type;
    delete seoParams.seo_decode_type;
    delete seoParams.queryObject;
    delete seoParams.surrounding;
    delete seoParams.geo;
    delete seoParams.publisherType;
    delete seoParams.misc;
    delete seoParams.features;
    return seoParams;
  } else {
    var _seoParams = Object.assign({}, params, {
      locations: params.geo ? convertGeoToLocationsForEncode(params.geo) : []
    }, params.propertyTypes ? {
      propertyTypes: convertPropertyTypesForEncode(params.propertyTypes)
    } : null, convertSeoDecQOForEncode(params), params.rooms ? {
      numRoomsMin: params.rooms,
      numRoomsMax: params.rooms
    } : null, params.price && params.price.from ? {
      priceMin: params.price.from
    } : null, params.price && params.price.to ? {
      priceMax: params.price.to
    } : null, params.publisher ? {
      sellerType: params.publisher
    } : null, params.license_type_groups ? {
      license_type_groups: convertLicenseTypeGroupForEncode(params.license_type_groups)
    } : null);

    delete _seoParams.seo_manager_type;
    delete _seoParams.seo_decode_type;
    delete _seoParams.queryObject;
    delete _seoParams.rooms;
    delete _seoParams.price;
    delete _seoParams.publisher;
    delete _seoParams.publisherType;
    delete _seoParams.misc;
    delete _seoParams.features;
    return _seoParams;
  }
};

exports.convertParamsForEncode = convertParamsForEncode;